import { TextDisplayCell } from "../../../common/components/DataGrid";
import { generateCodeLegendCell } from "../../helpers/CellGenerators";

export const CodeLegendCell = ({ row, codeLegends }) => {
  return <TextDisplayCell value={generateCodeLegendCell(row, codeLegends)} />;
};
